import { render, staticRenderFns } from "./DifferenceGame.vue?vue&type=template&id=e993712e&scoped=true&"
import script from "./DifferenceGame.vue?vue&type=script&lang=js&"
export * from "./DifferenceGame.vue?vue&type=script&lang=js&"
import style0 from "./DifferenceGame.vue?vue&type=style&index=0&id=e993712e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e993712e",
  null
  
)

export default component.exports